import * as types from "./actionTypes";
import * as vehicleApi from "../../_api/vehicleApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadVehicleSuccess(vehicle) {
  return { type: types.LOAD_VEHICLE_SUCCESS, vehicle };
}

export function saveVehicleSuccess(vehicle) {
  return { type: types.SAVE_VEHICLE_SUCCESS, vehicle };
}

export function updateVehicleSuccess(vehicle) {
  return { type: types.UPDATE_VEHICLE_SUCCESS, vehicle };
}

export function addVehicleSuccess(vehicle) {
  return { type: types.ADD_VEHICLE_SUCCESS, vehicle };
}

export function loadVehicle(ClientId, UserID, StateOfConviction) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .getVehicle(ClientId, UserID, StateOfConviction)
      .then((vehicle) => {
        if (vehicle.length === 0) {
          dispatch(loadVehicleSuccess([{ CurrentState: "None" }]));
        } else {
          vehicle.sort(
            ({ vehicleId: previousID }, { vehicleId: currentID }) =>
              previousID - currentID
          );
          dispatch(loadVehicleSuccess(vehicle));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveVehicle(id, params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .updateVehicle(id, params)
      .then(() => {
        dispatch(saveVehicleSuccess(params));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function addVehicle(params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .addVehicle(params)
      .then((returnObj) => {
        dispatch(addVehicleSuccess(returnObj));
        return returnObj.vehicleId;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function updateVehicle(vehicleObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return vehicleApi
      .updateVehicle(vehicleObj)
      .then(() => {
        dispatch(saveVehicleSuccess(vehicleObj));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
